import { render, staticRenderFns } from "./CardManager.vue?vue&type=template&id=28f42a9e&scoped=true&"
import script from "./CardManager.vue?vue&type=script&lang=js&"
export * from "./CardManager.vue?vue&type=script&lang=js&"
import style0 from "./CardManager.vue?vue&type=style&index=0&id=28f42a9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f42a9e",
  null
  
)

export default component.exports